import { collection, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";

export const fetchCollectionData = async (
  collectionName,
  onUpdate,
  onError
) => {
  try {
    // const query = await getDocs(collection(db, collectionName));
    // const data = query.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    // return data;

    const unSub = onSnapshot(
      collection(db, collectionName),
      (querySnapshot) => {
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        onUpdate(data);
      },
      (error) => {
        console.error("Error fetching real-time data:", error);
        if (onError) {
          onError(error.message);
        }
      }
    );
    return unSub;
  } catch (error) {
    console.error("Error setting up the real-time listener:", error);
  }
};
